/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import { Select, useMantineColorScheme } from '@mantine/core';

const SelectDropdown = ({
  value, options, onChange,
}) => {
  const { colorScheme } = useMantineColorScheme();

  const isDark = colorScheme === 'dark';
  return (
    <Select
      className={`w-full ${isDark ? 'dark-select' : ''}`}
      value={value}
      onChange={onChange}
      data={options.map((opt) => ({ value: opt, label: opt }))}
      // radius="lg"
      size="xs"
      withinPortal
      searchable={false}
      styles={(theme) => ({
        input: {
          fontWeight: 500,
          backgroundColor: isDark ? '#3A3A3A !important' : theme.white,
          color: isDark ? '#beb9b9' : theme.black,
          border: isDark ? '1px solid #44403c' : `1px solid ${theme.colors.gray[3]}`,
          '&:focus': {
            borderColor: isDark ? '#44403c' : theme.colors.blue[5],
          },
        },
        dropdown: {
          backgroundColor: isDark ? '#3A3A3A !important' : theme.white,
          border: isDark ? '1px solid #44403c' : `1px solid ${theme.colors.gray[3]}`,
        },
        item: {
          backgroundColor: isDark ? '#3A3A3A' : theme.white,
          color: isDark ? '#beb9b9' : theme.black,
          transition: 'background-color 0.15s ease, color 0.15s ease',
          '&[data-hovered]': {
            backgroundColor: isDark ? '#3A3A3A' : theme.colors.gray[0],
          },
          '&[data-selected]': {
            backgroundColor: isDark ? '#1E1E1E' : theme.colors.blue[1],
            color: isDark ? '#fff' : theme.black,
          },
          '&[data-selected][data-hovered]': {
            backgroundColor: isDark ? '#1E1E1E' : theme.colors.blue[2],
          },
        },
      })}
    />
  );
};

export default SelectDropdown;
